module.exports = __webpack_public_path__ + "static/media/IntroDemo07b-blank.f528092a.png";